import { useEffect, useCallback } from "react";
import { io } from "socket.io-client";

// Create a single socket connection
// const socket = io("wss://artcollect.io", {
//   transports: ["websocket"],
//   reconnection: true,
//   reconnectionAttempts: 5,
//   reconnectionDelay: 1000,
// });
const socket = io(process.env.REACT_APP_SOCKET_SERVER_URL, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});
const showBrowserNotification = (title, options = {}) => {
  if (!("Notification" in window)) return;

  if (Notification.permission === "granted") {
    new Notification(title, options);
  } else if (Notification.permission !== "denied") {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        new Notification(title, options);
      }
    });
  }
};

const useRegisterWallet = (toastRef) => {
  const registerWallet = useCallback(() => {
    const walletAddress = localStorage.getItem("walletAddress");
    if (walletAddress) {
      // console.log("📡 Registering wallet:", walletAddress);
      socket.emit("authenticate", walletAddress);
    }
  }, []);

  useEffect(() => {
    // Handle connection events
    const onConnect = () => {
      //console.log("🔗 Socket connected:", socket.id);
      registerWallet();
    };

    const onDisconnect = () => {
      // console.log("🔌 Socket disconnected");
    };

    const onReconnect = (attempt) => {
      /// console.log(`♻️ Reconnected (attempt ${attempt})`);
      registerWallet();
    };

    // Handle storage changes (multi-tab support)
    const handleStorage = (e) => {
      if (e.key === "walletAddress") {
        // console.log("🔁 Wallet changed in another tab:", e.newValue);
        registerWallet();
      }
    };

    // Set up event listeners
    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("reconnect", onReconnect);
    window.addEventListener("storage", handleStorage);

    // Notification handlers
    socket.on("new-bid", (data) => {
      //console.log("📬 New Offer Received:", data);
      const message = `New offer of ${data.offerAmount} tez received for NFT ${data.nftId}!`;

      toastRef.current?.addToast(message, "info");
      showBrowserNotification("New Offer Received", {
        body: message,
        icon: "/notification-icon.png",
      });
    });

    socket.on("bid-accepted", (data) => {
      //console.log("🎉 Offer accepted:", data);
      const message = `Your offer of ${data.offerAmount} tez for NFT ${data.nftId} has been accepted!`;

      toastRef.current?.addToast(message, "success");
      showBrowserNotification("Offer Accepted", {
        body: message,
        icon: "/success-icon.png",
      });
    });

    socket.on("offer-notification", (data) => {
      //console.log("📬 Offer made on your NFT:", data);
      const message = `You have received an offer of ${data.offerAmount} tez for your NFT ${data.nftId}`;

      toastRef.current?.addToast(message, "info");
      showBrowserNotification("New Offer on Your NFT", {
        body: `From: ${data.senderWallet}\nAmount: ${data.offerAmount} tez`,
        icon: "/nft-icon.png",
      });
    });

    // Initial registration
    registerWallet();

    // Cleanup
    return () => {
      window.removeEventListener("storage", handleStorage);
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("reconnect", onReconnect);
      socket.off("new-bid");
      socket.off("bid-accepted");
      socket.off("offer-notification");
    };
  }, [registerWallet, toastRef]);

  // Expose socket for other components if needed
  return { socket };
};

export default useRegisterWallet;
